<generic-incident-modal [parent]="this" [busy]="busy">
    <form [formGroup]="form">
        <h2>Affidavit Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label [ngClass]="{ 'required': complaintNumberRequired }" [attr.title]="complaintNumberRequired ? '* Required' : null">Complaint Number</label>
                    <input class="mvd_form-control" type="text" formControlName="complaintNumber" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label [ngClass]="{ 'required': citingAgencyRequired }" [attr.title]="citingAgencyRequired ? '* Required' : null">Citing Agency</label>
                    <select class="mvd_form-control" formControlName="citingAgencyTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of citingAgencyTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
            </div>
            <label>Charges</label>
            <div class="row">
                <div class="col-md-2 mvd_form-group">
                    <label class="required" title="* Required">Charge 1</label>
                    <input class="mvd_form-control" type="text" formControlName="charge1" />
                </div>
                <div class="col-md-2 mvd_form-group">
                    <label>Charge 2</label>
                    <input class="mvd_form-control" type="text" formControlName="charge2" />
                </div>
                <div class="col-md-2 mvd_form-group">
                    <label>Charge 3</label>
                    <input class="mvd_form-control" type="text" formControlName="charge3" />
                </div>
                <div class="col-md-2 mvd_form-group">
                    <label>Charge 4</label>
                    <input class="mvd_form-control" type="text" formControlName="charge4" />
                </div>
                <div class="col-md-2 mvd_form-group">
                    <label>Charge 5</label>
                    <input class="mvd_form-control" type="text" formControlName="charge5" />
                </div>
                <div class="col-md-2 mvd_form-group">
                    <label>Charge 6</label>
                    <input class="mvd_form-control" type="text" formControlName="charge6" />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mvd_form-group">
                    <label>Other Charges</label>
                    <input class="mvd_form-control" type="text" formControlName="otherChargeDisplay" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label [ngClass]="{ 'required': arrestTimeRequired }" [attr.title]="arrestTimeRequired ? '* Required' : null">Arrest Time (####)</label>
                    <input class="mvd_form-control" type="text" formControlName="arrestTime" />
                </div>
                <div class="col-sm-9 mvd_form-group">
                    <label>Arrest Location</label>
                    <input class="mvd_form-control" type="text" formControlName="arrestLocation" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label class="required--multi" title="* Either probable cause or reasonable grounds must be selected.">Probable Cause</label>
                    <input type="checkbox" formControlName="probableCauseIndicator" />
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label class="required--multi" title="* Either probable cause or reasonable grounds must be selected.">Reasonable Grounds</label>
                    <input type="checkbox" formControlName="reasonableGroundsIndicator" />
                </div>
                <div class="col-md-3 mvd_form-group">
                    <label>CDL Holder</label>
                    <input type="checkbox" formControlName="isCDLHolder" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Probable Cause Facts</label>
                    <input class="mvd_form-control" type="text" formControlName="probableCauseFacts" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Reasonable Grounds Facts</label>
                    <input class="mvd_form-control" type="text" formControlName="reasonableGroundsFacts" />
                </div>
            </div>
            <label>Violation Circumstances</label>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Violation Occurred in Commercial Vehicle</label>
                    <input type="checkbox" formControlName="commercialMotorVehicleIndicator" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Violation Occurred while Transporting Hazardous Materials</label>
                    <input type="checkbox" formControlName="hazardousMaterialIndicator" />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Violation Occurred While Operating a 16+ Passenger Vehicle</label>
                    <input type="checkbox" formControlName="passengerIndicator" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Violation Occurred while Operating a VFH or as a TNC Driver</label>
                    <input type="checkbox" formControlName="operatingHireFlag" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Admonitions Read</label>
                    <input type="checkbox" formControlName="admonitionsReadIndicator" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label [ngClass]="{ 'required': adminPerSeTestTypeRequired }" [attr.title]="adminPerSeTestTypeRequired ? '* Required' : null">Admin Per Se Test Type</label>
                    <select class="mvd_form-control" formControlName="incidentAdminPerSeTestTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of incidentAdminPerSeTestTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Officer Initials</label>
                    <input class="mvd_form-control" type="text" formControlName="officerInitials" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>BAC Test Status</label>
                    <input class="mvd_form-control" type="text" formControlName="testStatusBAC" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>BAC Test Results 1</label>
                    <input class="mvd_form-control" type="text" formControlName="testResultsBAC1" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>BAC Test Results 2</label>
                    <input class="mvd_form-control" type="text" formControlName="testResultsBAC2" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Blood Test Results</label>
                    <input class="mvd_form-control" type="text" formControlName="bloodTestResults" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Blood Test Results BAC</label>
                    <input class="mvd_form-control" type="text" formControlName="bloodTestResultsBAC" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Drug Test Status</label>
                    <input class="mvd_form-control" type="text" formControlName="testStatusDrugs" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Drug Test Results</label>
                    <input class="mvd_form-control" type="text" formControlName="testResultsDrugs" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Person Refused Notes</label>
                    <input class="mvd_form-control" type="text" formControlName="personRefusedNotes" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label class="required" title="* Required">Accident Indicator</label>
                    <select class="mvd_form-control" formControlName="accidentTypeId">
                        <option [ngValue]="null">- Select -</option>
                        <option *ngFor="let t of accidentTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
            </div>
        </fieldset>
        <h2>Driver License Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Driver License Number</label>
                    <input class="mvd_form-control" type="text" formControlName="driverLicenseNumber" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Driver License Jurisdiction</label>
                    <select class="mvd_form-control" formControlName="driverLicenseJurisdictionId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of jurisdictions" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
            </div>
        </fieldset>
        <h2>Other Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Law Enforcement Officer Name</label>
                    <input class="mvd_form-control" type="text" formControlName="officerName" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Badge Number</label>
                    <input class="mvd_form-control" type="text" formControlName="officerBadge" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Officer Signature</label>
                    <input class="mvd_form-control" type="text" formControlName="officerSignature" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Officer Station</label>
                    <input class="mvd_form-control" type="text" formControlName="officerStation" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label class="required" title="* Required">Law Enforcement (ORI) Name</label>
                    <select class="mvd_form-control" formControlName="lawEnforcementAgencyId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of lawEnforcementAgencies" [value]="t.value" [disabled]="true == t.disabled">{{ t.text }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Test Operator Name</label>
                    <input class="mvd_form-control" type="text" formControlName="testOperatorName" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Test Operator Badge Number</label>
                    <input class="mvd_form-control" type="text" formControlName="testOperatorNumber" />
                </div>
            </div>
            <div class="row" class="col-sm-6 mvd_form-group">
                <h2>Additional Officers</h2>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Law Enforcement Officer Name</label>
                    <input class="mvd_form-control" type="text" formControlName="officerName2" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Badge Number</label>
                    <input class="mvd_form-control" type="text" formControlName="officerBadge2" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Law Enforcement Officer Name</label>
                    <input class="mvd_form-control" type="text" formControlName="officerName3" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Badge Number</label>
                    <input class="mvd_form-control" type="text" formControlName="officerBadge3" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Law Enforcement Officer Name</label>
                    <input class="mvd_form-control" type="text" formControlName="officerName4" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Badge Number</label>
                    <input class="mvd_form-control" type="text" formControlName="officerBadge4" />
                </div>
            </div>
        </fieldset>
        <h2>Surrender of License and Temp Permit Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Suspension Served</label>
                    <input type="checkbox" formControlName="suspensionServedIndicator" />
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Suspension Served Date</label>
                    <max-calendar formControlName="suspensionServedDate" [showIcon]="true" >
                    </max-calendar>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Suspension Served Time (####)</label>
                    <input class="mvd_form-control" type="text" formControlName="suspensionServedTime" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4 mvd_form-group">
                    <label>Eye Color</label>
                    <select class="mvd_form-control" formControlName="tempPermitEyeColorTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of eyeColorTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Hair Color</label>
                    <select class="mvd_form-control" formControlName="tempPermitHairColorTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of hairColorTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
                <div class="col-sm-4 mvd_form-group">
                    <label>Driver License Class</label>
                    <select class="mvd_form-control" formControlName="tempPermitDriverLicenseClassTypeId">
                        <option [value]="null">- Select -</option>
                        <option *ngFor="let t of driverLicenseClassTypes" [value]="t.value">{{ t.text }}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Endorsements</label>
                    <input class="mvd_form-control" type="text" formControlName="tempPermitEndorsements" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Restrictions</label>
                    <input class="mvd_form-control" type="text" formControlName="tempPermitRestrictions" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Permit Not Issued Reason</label>
                    <input class="mvd_form-control" type="text" formControlName="tempPermitPermitNotIssuedReason" />
                </div>
            </div>
        </fieldset>
        <h2>Admonitions Information</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label>Consents To Testing</label>
                    <input type="checkbox" formControlName="selectConsentToTestIndicator" />
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>First Admonition Read</label>
                    <input type="checkbox" formControlName="selectAdmonitions1Indicator" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Consents to Testing After First Admonitions Read</label>
                    <input type="checkbox" formControlName="selectConsentToTestYIndicator" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Arrestees Comments</label>
                    <input class="mvd_form-control" type="text" formControlName="arresteesComments1" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label>Second Admonition Read</label>
                    <input type="checkbox" formControlName="selectAdmonitions2Indicator" />
                </div>
                <div class="col-sm-7 mvd_form-group">
                    <label>Consents to Testing After Second Admonitions Read</label>
                    <input type="checkbox" formControlName="selectConsentToTestNIndicator" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Arrestees Comments</label>
                    <input class="mvd_form-control" type="text" formControlName="arresteesComments2" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-5 mvd_form-group">
                    <label>Third Admonition Read</label>
                    <input type="checkbox" formControlName="selectAdmonitions3Indicator" />
                </div>
                <div class="col-sm-7 mvd_form-group">
                    <label>Consents to Testing After Third Admonitions Read</label>
                    <input type="checkbox" formControlName="selectConsentToTestNDelayedIndicator" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Arrestees Comments</label>
                    <input class="mvd_form-control" type="text" formControlName="arresteesComments3" />
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Additional Comments</label>
                    <input class="mvd_form-control" type="text" formControlName="arrestComments" />
                </div>
            </div>
        </fieldset>
    </form>
</generic-incident-modal>